import React from 'react';
import { Box, Stack } from '@mui/material';
import {
  Card,
  ListItemCardContent,
  ListItemCardTitle,
  ListItemCardSubtitle,
  Link,
} from '@marageti/z4-lib';

import { AuditCategory } from './types';

interface AuditCategoryCardProps {
  category: AuditCategory;
}

const AuditCategoryCard = ({ category }: AuditCategoryCardProps) => {
  const href = category.path;
  const title = category.label;
  const subTitle = category.description;
  const { icon } = category;
  return (
    <Link
      to={href}
      sx={{
        maxWidth: {
          desktop: '434px',
        },
        width: {
          desktop: '100%',
        },
      }}
    >
      <Card
        sx={{
          '&:hover': {
            bgcolor: 'grey.A100',
          },
          height: '100%',
        }}
      >
        <ListItemCardContent>
          <Stack>
            <ListItemCardTitle>{title}</ListItemCardTitle>
            <ListItemCardSubtitle>{subTitle}</ListItemCardSubtitle>
          </Stack>
          {icon && (
          <Box sx={{
            display: 'flex', justifyContent: 'center', alignItems: 'center', ml: 2,
          }}
          >
            {icon}
          </Box>
          )}
        </ListItemCardContent>
      </Card>
    </Link>
  );
};

export default AuditCategoryCard;
